import React, { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { USER_ROLES } from '../config/security'
import './Empresas.css'

const Empresas = ({ userRole, onClose }) => {
  const [empresas, setEmpresas] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editingEmpresa, setEditingEmpresa] = useState(null)
  const [formData, setFormData] = useState({
    empresa: '',
    razao_social: '',
    cnpj: '',
    endereco: '',
    contato: '',
    email: '',
    cidade: '',
    estado: '',
    cep: '',
    responsavel: '',
    cpf_responsavel: '',
    logo: '',
    cor_primaria_contrato: '',
    cor_destaque_contrato: '',
    ativa: true
  })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [saving, setSaving] = useState(false)
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorDetails, setErrorDetails] = useState('')
  const [uploadingLogo, setUploadingLogo] = useState(false)
  // Arquivo de logo selecionado (enviado ao bucket "logos" somente ao salvar)
  const [logoFile, setLogoFile] = useState(null)
  const [logoPreview, setLogoPreview] = useState(null)
  const [showDadosBancariosModal, setShowDadosBancariosModal] = useState(false)
  const [empresaDadosBancarios, setEmpresaDadosBancarios] = useState(null)
  const [formDadosBancarios, setFormDadosBancarios] = useState({ banco: '', agencia: '', conta: '', chave_pix: '' })
  const [savingDadosBancarios, setSavingDadosBancarios] = useState(false)
  const [consultandoCnpj, setConsultandoCnpj] = useState(false)
  const [showParametrosVistoriaModal, setShowParametrosVistoriaModal] = useState(false)
  const [empresaParametrosVistoria, setEmpresaParametrosVistoria] = useState(null)
  const [parametrosVistoria, setParametrosVistoria] = useState([])
  const [loadingParametrosVistoria, setLoadingParametrosVistoria] = useState(false)
  const [savingParametroVistoria, setSavingParametroVistoria] = useState(false)
  const [editandoParametroVistoriaId, setEditandoParametroVistoriaId] = useState(null)
  const [formParametroVistoria, setFormParametroVistoria] = useState({ tipo_veiculo: 'carro', valor_km: '', km_almoco: '', valor_almoco: '' })

  const BRASIL_API_CNPJ = 'https://brasilapi.com.br/api/cnpj/v1'

  const montarEnderecoCnpj = (d) => {
    const tipo = (d.descricao_tipo_de_logradouro || '').trim()
    const log = (d.logradouro || '').trim()
    const linhaLog = [tipo, log].filter(Boolean).join(' ').trim()
    const num = (d.numero || '').trim()
    const compl = (d.complemento || '').trim()
    const bairro = (d.bairro || '').trim()
    const partes = []
    if (linhaLog) {
      partes.push(num ? `${linhaLog}, nº ${num}` : linhaLog)
    } else if (num) {
      partes.push(`nº ${num}`)
    }
    if (compl) partes.push(compl)
    if (bairro) partes.push(bairro)
    return partes.join(', ')
  }

  const handleBuscarCnpj = async () => {
    const digits = (formData.cnpj || '').replace(/\D/g, '')
    if (digits.length !== 14) {
      showError('CNPJ incompleto', 'Digite os 14 dígitos do CNPJ antes de buscar.')
      return
    }
    if (!validateCNPJ(formData.cnpj)) {
      showError('CNPJ inválido', 'Verifique os dígitos do CNPJ e tente novamente.')
      return
    }
    try {
      setConsultandoCnpj(true)
      setError('')
      setSuccess('')
      const res = await fetch(`${BRASIL_API_CNPJ}/${digits}`)
      if (res.status === 404) {
        showError('CNPJ não encontrado', 'Não foi possível localizar este CNPJ na base pública.')
        return
      }
      if (!res.ok) {
        let detalhe = `Código HTTP ${res.status}`
        try {
          const errBody = await res.json()
          if (errBody.message) detalhe = errBody.message
        } catch {
          /* ignore */
        }
        showError('Erro ao consultar CNPJ', detalhe)
        return
      }
      const d = await res.json()
      const cnpjFmt = formatCNPJ(d.cnpj || digits)
      const nomeExibicao = (d.nome_fantasia && String(d.nome_fantasia).trim())
        ? String(d.nome_fantasia).trim()
        : (d.razao_social || '').trim()
      const telDigits = String(d.ddd_telefone_1 || '').replace(/\D/g, '').slice(0, 11)
      const contatoPreenchido = telDigits.length >= 10 ? formatPhone(telDigits) : formData.contato
      const cepFmt = d.cep ? formatCEP(String(d.cep)) : formData.cep
      const emailApi = d.email && String(d.email).includes('@') ? String(d.email).trim() : null

      setFormData((prev) => ({
        ...prev,
        empresa: nomeExibicao || prev.empresa,
        razao_social: (d.razao_social || '').trim() || prev.razao_social,
        cnpj: cnpjFmt,
        endereco: montarEnderecoCnpj(d) || prev.endereco,
        cidade: (d.municipio || '').trim() || prev.cidade,
        estado: (d.uf || '').trim().toUpperCase().slice(0, 2) || prev.estado,
        cep: cepFmt || prev.cep,
        contato: contatoPreenchido,
        email: emailApi || prev.email
      }))

      const situacao = (d.descricao_situacao_cadastral || '').toUpperCase()
      if (situacao && situacao !== 'ATIVA') {
        setSuccess(`Dados carregados. Situação na Receita: ${d.descricao_situacao_cadastral}.`)
        setTimeout(() => setSuccess(''), 8000)
      } else {
        setSuccess('Dados da empresa preenchidos a partir do CNPJ.')
        setTimeout(() => setSuccess(''), 4000)
      }
    } catch (err) {
      console.error('Erro ao buscar CNPJ:', err)
      showError(
        'Falha na consulta',
        err.message || 'Verifique sua conexão ou tente novamente em instantes.'
      )
    } finally {
      setConsultandoCnpj(false)
    }
  }

  // Seleção da logo: apenas guarda o arquivo e mostra um preview local.
  // O upload para o bucket "logos" acontece ao salvar/atualizar a empresa.
  const handleLogoSelect = (event) => {
    const file = event.target.files && event.target.files[0]
    if (!file) return

    if (!file.type.startsWith('image/')) {
      showError('Arquivo inválido', 'Selecione um arquivo de imagem para a logo.')
      return
    }
    if (file.size > 10 * 1024 * 1024) {
      showError('Imagem muito grande', 'A logo deve ter no máximo 10MB.')
      return
    }

    if (logoPreview) URL.revokeObjectURL(logoPreview)
    setLogoFile(file)
    setLogoPreview(URL.createObjectURL(file))
  }

  // Faz o upload da logo para o bucket "logos" e retorna a URL pública.
  const uploadLogoToBucket = async (file) => {
    const fileExt = file.name.split('.').pop()
    const fileName = `${Date.now()}_${Math.random().toString(36).substring(7)}.${fileExt}`

    const { error: uploadError } = await supabase.storage
      .from('logos')
      .upload(fileName, file, { cacheControl: '3600', upsert: false })

    if (uploadError) {
      if (uploadError.message && uploadError.message.includes('Bucket not found')) {
        throw new Error('Bucket "logos" não encontrado. Crie o bucket "logos" no Supabase Storage.')
      }
      throw uploadError
    }

    const { data } = supabase.storage.from('logos').getPublicUrl(fileName)
    return data.publicUrl
  }

  // Limpa a seleção de logo (arquivo + preview)
  const limparLogoSelecionada = () => {
    if (logoPreview) URL.revokeObjectURL(logoPreview)
    setLogoFile(null)
    setLogoPreview(null)
  }

  // Funções de máscara
  const formatCNPJ = (value) => {
    const numbers = value.replace(/\D/g, '')
    return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
  }

  const formatCPF = (value) => {
    const numbers = value.replace(/\D/g, '')
    return numbers.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
  }

  const formatPhone = (value) => {
    const numbers = value.replace(/\D/g, '')
    if (numbers.length <= 10) {
      return numbers.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3')
    }
    return numbers.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
  }

  const formatCEP = (value) => {
    const numbers = value.replace(/\D/g, '')
    return numbers.replace(/^(\d{5})(\d{3})$/, '$1-$2')
  }

  // Validação de CNPJ
  const validateCNPJ = (cnpj) => {
    if (!cnpj) return true // Campo opcional
    const numbers = cnpj.replace(/\D/g, '')
    if (numbers.length !== 14) return false
    
    // Validação básica de CNPJ
    let sum = 0
    let weight = 5
    for (let i = 0; i < 12; i++) {
      sum += parseInt(numbers[i]) * weight
      weight = weight === 2 ? 9 : weight - 1
    }
    const digit1 = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    
    sum = 0
    weight = 6
    for (let i = 0; i < 13; i++) {
      sum += parseInt(numbers[i]) * weight
      weight = weight === 2 ? 9 : weight - 1
    }
    const digit2 = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    
    return parseInt(numbers[12]) === digit1 && parseInt(numbers[13]) === digit2
  }

  // Validação de CPF
  const validateCPF = (cpf) => {
    if (!cpf) return true // Campo opcional
    const numbers = cpf.replace(/\D/g, '')
    if (numbers.length !== 11) return false
    
    // Validação básica de CPF
    let sum = 0
    for (let i = 0; i < 9; i++) {
      sum += parseInt(numbers[i]) * (10 - i)
    }
    const digit1 = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    
    sum = 0
    for (let i = 0; i < 10; i++) {
      sum += parseInt(numbers[i]) * (11 - i)
    }
    const digit2 = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    
    return parseInt(numbers[9]) === digit1 && parseInt(numbers[10]) === digit2
  }

  // Função para exibir erro em modal de prioridade máxima
  const showError = (message, details = '') => {
    setErrorDetails(details)
    setError(message)
    setShowErrorModal(true)
    setSaving(false)
  }

  // Função para fechar modal de erro
  const closeErrorModal = () => {
    setShowErrorModal(false)
    setErrorDetails('')
    setError('')
  }

  // Carregar empresas
  useEffect(() => {
    fetchEmpresas()
  }, [])

  // Verificar se o usuário é administrador
  if (userRole !== USER_ROLES.ADMINISTRADOR) {
    return (
      <div className="empresas-container">
        <div className="empresas-header">
          <h2>Gerenciamento de Empresas</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="access-denied">
          <h3>Acesso Negado</h3>
          <p>Você não tem permissão para acessar esta funcionalidade.</p>
          <p>Apenas administradores podem gerenciar empresas.</p>
        </div>
      </div>
    )
  }

  const fetchEmpresas = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('empresa')
        .select('*')
        .order('empresa')

      if (error) throw error
      setEmpresas(data || [])
    } catch (error) {
      console.error('Erro ao carregar empresas:', error)
      showError('Erro ao carregar empresas', 'Não foi possível carregar a lista de empresas. Verifique sua conexão e tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  // Limpar formulário
  const clearForm = () => {
    setFormData({ 
      empresa: '',
      razao_social: '',
      cnpj: '',
      endereco: '',
      contato: '',
      email: '',
      cidade: '',
      estado: '',
      cep: '',
      responsavel: '',
      cpf_responsavel: '',
      logo: '',
      cor_primaria_contrato: '',
      cor_destaque_contrato: '',
      ativa: true
    })
    limparLogoSelecionada()
    setEditingEmpresa(null)
    setError('')
    setSuccess('')
  }

  // Abrir formulário para criar nova empresa
  const handleCreate = () => {
    clearForm()
    setShowForm(true)
  }

  // Abrir formulário para editar empresa
  const handleEdit = (empresa) => {
    setFormData({ 
      empresa: empresa.empresa || '',
      razao_social: empresa.razao_social || '',
      cnpj: empresa.cnpj || '',
      endereco: empresa.endereco || '',
      contato: empresa.contato || '',
      email: empresa.email || '',
      cidade: empresa.cidade || '',
      estado: empresa.estado || '',
      cep: empresa.cep || '',
      responsavel: empresa.responsavel || '',
      cpf_responsavel: empresa.cpf_responsavel || '',
      logo: empresa.logo || '',
      cor_primaria_contrato: empresa.cor_primaria_contrato || '',
      cor_destaque_contrato: empresa.cor_destaque_contrato || '',
      ativa: empresa.ativa !== undefined ? empresa.ativa : true
    })
    limparLogoSelecionada()
    setEditingEmpresa(empresa)
    setShowForm(true)
    setError('')
    setSuccess('')
  }

  // Salvar empresa (criar ou editar)
  const handleSave = async () => {
    try {
      setError('')
      setSuccess('')
      setSaving(true)

      // Validações
      if (!formData.empresa.trim()) {
        showError('Nome da empresa é obrigatório', 'O campo "Nome da Empresa" deve ser preenchido para criar uma nova empresa.')
        return
      }

      if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        showError('Email inválido', 'Por favor, verifique o formato do email. Exemplo: contato@empresa.com.br')
        return
      }

      if (formData.cnpj && !validateCNPJ(formData.cnpj)) {
        showError('CNPJ inválido', 'O CNPJ informado não é válido. Verifique se todos os dígitos estão corretos.')
        return
      }

      if (formData.cpf_responsavel && !validateCPF(formData.cpf_responsavel)) {
        showError('CPF do responsável inválido', 'O CPF informado não é válido. Verifique se todos os dígitos estão corretos.')
        return
      }

      // Se houver uma nova logo selecionada, envia para o bucket "logos" e usa a URL retornada.
      let logoUrl = formData.logo.trim() || null
      if (logoFile) {
        setUploadingLogo(true)
        try {
          logoUrl = await uploadLogoToBucket(logoFile)
        } finally {
          setUploadingLogo(false)
        }
      }

      if (editingEmpresa) {
        // Atualizar empresa existente
        const { error } = await supabase
          .from('empresa')
          .update({ 
            empresa: formData.empresa.trim(),
            razao_social: formData.razao_social.trim() || null,
            cnpj: formData.cnpj.trim() || null,
            endereco: formData.endereco.trim() || null,
            contato: formData.contato.trim() || null,
            email: formData.email.trim() || null,
            cidade: formData.cidade.trim() || null,
            estado: formData.estado.trim() || null,
            cep: formData.cep.trim() || null,
            responsavel: formData.responsavel.trim() || null,
            cpf_responsavel: formData.cpf_responsavel.trim() || null,
            logo: logoUrl,
            cor_primaria_contrato: formData.cor_primaria_contrato.trim() || null,
            cor_destaque_contrato: formData.cor_destaque_contrato.trim() || null,
            ativa: formData.ativa,
            updated_at: new Date().toISOString()
          })
          .eq('id', editingEmpresa.id)

        if (error) throw error
        setSuccess('Empresa atualizada com sucesso!')
      } else {
        // Criar nova empresa
        const { error } = await supabase
          .from('empresa')
          .insert([{ 
            empresa: formData.empresa.trim(),
            razao_social: formData.razao_social.trim() || null,
            cnpj: formData.cnpj.trim() || null,
            endereco: formData.endereco.trim() || null,
            contato: formData.contato.trim() || null,
            email: formData.email.trim() || null,
            cidade: formData.cidade.trim() || null,
            estado: formData.estado.trim() || null,
            cep: formData.cep.trim() || null,
            responsavel: formData.responsavel.trim() || null,
            cpf_responsavel: formData.cpf_responsavel.trim() || null,
            logo: logoUrl,
            cor_primaria_contrato: formData.cor_primaria_contrato.trim() || null,
            cor_destaque_contrato: formData.cor_destaque_contrato.trim() || null,
            ativa: formData.ativa
          }])

        if (error) throw error
        setSuccess('Empresa criada com sucesso!')
      }

      // Recarregar lista e fechar formulário
      await fetchEmpresas()
      setTimeout(() => {
        setShowForm(false)
        clearForm()
      }, 1500)

    } catch (error) {
      console.error('Erro ao salvar empresa:', error)
      
      let errorMessage = 'Erro ao salvar empresa'
      let errorDetails = 'Ocorreu um erro inesperado. Tente novamente.'
      
      if (error.code === '23505') {
        errorMessage = 'Empresa já existe'
        errorDetails = 'Já existe uma empresa com este nome. Por favor, escolha um nome diferente.'
      } else if (error.code === '23502') {
        errorMessage = 'Campo obrigatório não preenchido'
        errorDetails = 'Verifique se todos os campos obrigatórios estão preenchidos corretamente.'
      } else if (error.message) {
        errorDetails = error.message
      }
      
      showError(errorMessage, errorDetails)
    }
  }

  // Alternar status ativo/inativo da empresa
  const handleToggleStatus = async (empresa) => {
    try {
      setError('')
      setSuccess('')

      const novoStatus = !empresa.ativa
      const { error } = await supabase
        .from('empresa')
        .update({ 
          ativa: novoStatus,
          updated_at: new Date().toISOString()
        })
        .eq('id', empresa.id)

      if (error) throw error

      setSuccess(`Empresa ${novoStatus ? 'ativada' : 'desativada'} com sucesso!`)
      await fetchEmpresas()
      
      setTimeout(() => setSuccess(''), 3000)

    } catch (error) {
      console.error('Erro ao alterar status da empresa:', error)
      showError('Erro ao alterar status da empresa', 'Não foi possível alterar o status da empresa. Tente novamente.')
    }
  }



  // Fechar formulário
  const handleCloseForm = () => {
    setShowForm(false)
    clearForm()
  }

  // Abrir modal de dados bancários
  const openDadosBancarios = (empresa) => {
    setEmpresaDadosBancarios(empresa)
    setFormDadosBancarios({
      banco: empresa.banco || '',
      agencia: empresa.agencia || '',
      conta: empresa.conta || '',
      chave_pix: empresa.chave_pix || ''
    })
    setShowDadosBancariosModal(true)
  }

  const closeDadosBancarios = () => {
    setShowDadosBancariosModal(false)
    setEmpresaDadosBancarios(null)
    setFormDadosBancarios({ banco: '', agencia: '', conta: '', chave_pix: '' })
  }

  const handleSaveDadosBancarios = async (e) => {
    e.preventDefault()
    if (!empresaDadosBancarios) return
    try {
      setSavingDadosBancarios(true)
      setError('')
      const { error: updateError } = await supabase
        .from('empresa')
        .update({
          banco: formDadosBancarios.banco.trim() || null,
          agencia: formDadosBancarios.agencia.trim() || null,
          conta: formDadosBancarios.conta.trim() || null,
          chave_pix: formDadosBancarios.chave_pix.trim() || null,
          updated_at: new Date().toISOString()
        })
        .eq('id', empresaDadosBancarios.id)
      if (updateError) throw updateError
      setSuccess('Dados bancários salvos com sucesso!')
      await fetchEmpresas()
      setTimeout(() => {
        closeDadosBancarios()
        setSuccess('')
      }, 1500)
    } catch (err) {
      console.error('Erro ao salvar dados bancários:', err)
      showError('Erro ao salvar dados bancários', err.message || 'Tente novamente.')
    } finally {
      setSavingDadosBancarios(false)
    }
  }

  // ===== Parâmetros de vistoria =====
  const getEmptyParametroVistoria = () => ({ tipo_veiculo: 'carro', valor_km: '', km_almoco: '', valor_almoco: '' })

  const parseValorParametro = (valor) => {
    if (valor === null || valor === undefined || valor === '') return 0
    const limpo = String(valor).replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '')
    const num = parseFloat(limpo)
    return isNaN(num) ? 0 : num
  }

  const formatarNumeroParametro = (valor) => {
    if (valor === null || valor === undefined || valor === '') return ''
    const num = typeof valor === 'number' ? valor : parseFloat(valor)
    if (isNaN(num)) return ''
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  const fetchParametrosVistoria = async (empresaId) => {
    try {
      setLoadingParametrosVistoria(true)
      const { data, error: fetchError } = await supabase
        .from('parametros_vistorias')
        .select('*')
        .eq('id_empresa', empresaId)
        .order('tipo_veiculo', { ascending: true })
      if (fetchError) throw fetchError
      setParametrosVistoria(data || [])
    } catch (err) {
      console.error('Erro ao carregar parâmetros de vistoria:', err)
      showError('Erro ao carregar parâmetros de vistoria', err.message || 'Tente novamente.')
    } finally {
      setLoadingParametrosVistoria(false)
    }
  }

  const openParametrosVistoria = (empresa) => {
    setEmpresaParametrosVistoria(empresa)
    setEditandoParametroVistoriaId(null)
    setFormParametroVistoria(getEmptyParametroVistoria())
    setParametrosVistoria([])
    setShowParametrosVistoriaModal(true)
    fetchParametrosVistoria(empresa.id)
  }

  const closeParametrosVistoria = () => {
    setShowParametrosVistoriaModal(false)
    setEmpresaParametrosVistoria(null)
    setEditandoParametroVistoriaId(null)
    setFormParametroVistoria(getEmptyParametroVistoria())
    setParametrosVistoria([])
  }

  const editarParametroVistoria = (parametro) => {
    setEditandoParametroVistoriaId(parametro.id)
    setFormParametroVistoria({
      tipo_veiculo: parametro.tipo_veiculo || 'carro',
      valor_km: formatarNumeroParametro(parametro.valor_km),
      km_almoco: formatarNumeroParametro(parametro.km_almoco),
      valor_almoco: formatarNumeroParametro(parametro.valor_almoco)
    })
  }

  const cancelarEdicaoParametroVistoria = () => {
    setEditandoParametroVistoriaId(null)
    setFormParametroVistoria(getEmptyParametroVistoria())
  }

  const handleSaveParametroVistoria = async (e) => {
    e.preventDefault()
    if (!empresaParametrosVistoria) return
    try {
      setSavingParametroVistoria(true)
      setError('')
      const payload = {
        id_empresa: empresaParametrosVistoria.id,
        tipo_veiculo: formParametroVistoria.tipo_veiculo,
        valor_km: parseValorParametro(formParametroVistoria.valor_km),
        km_almoco: parseValorParametro(formParametroVistoria.km_almoco),
        valor_almoco: parseValorParametro(formParametroVistoria.valor_almoco)
      }
      if (editandoParametroVistoriaId) {
        const { error: updateError } = await supabase
          .from('parametros_vistorias')
          .update({ ...payload, updated_at: new Date().toISOString() })
          .eq('id', editandoParametroVistoriaId)
        if (updateError) throw updateError
        setSuccess('Parâmetro atualizado com sucesso!')
      } else {
        const { error: insertError } = await supabase
          .from('parametros_vistorias')
          .insert([payload])
        if (insertError) throw insertError
        setSuccess('Parâmetro cadastrado com sucesso!')
      }
      setEditandoParametroVistoriaId(null)
      setFormParametroVistoria(getEmptyParametroVistoria())
      await fetchParametrosVistoria(empresaParametrosVistoria.id)
      setTimeout(() => setSuccess(''), 1500)
    } catch (err) {
      console.error('Erro ao salvar parâmetro de vistoria:', err)
      const msg = (err.code === '23505')
        ? 'Já existe um parâmetro cadastrado para esse tipo de veículo nesta empresa.'
        : (err.message || 'Tente novamente.')
      showError('Erro ao salvar parâmetro de vistoria', msg)
    } finally {
      setSavingParametroVistoria(false)
    }
  }

  const handleDeleteParametroVistoria = async (parametro) => {
    if (!window.confirm(`Excluir o parâmetro do veículo "${parametro.tipo_veiculo}"?`)) return
    try {
      setError('')
      const { error: deleteError } = await supabase
        .from('parametros_vistorias')
        .delete()
        .eq('id', parametro.id)
      if (deleteError) throw deleteError
      if (editandoParametroVistoriaId === parametro.id) cancelarEdicaoParametroVistoria()
      setSuccess('Parâmetro excluído com sucesso!')
      await fetchParametrosVistoria(empresaParametrosVistoria.id)
      setTimeout(() => setSuccess(''), 1500)
    } catch (err) {
      console.error('Erro ao excluir parâmetro de vistoria:', err)
      showError('Erro ao excluir parâmetro de vistoria', err.message || 'Tente novamente.')
    }
  }

  return (
    <div className="empresas-container">
      <div className="empresas-header">
        <div className="header-left">
          <button className="back-button" onClick={() => window.history.back()} title="Voltar">
            ← Voltar
          </button>
          <h2>Gerenciamento de Empresas</h2>
        </div>
        <button className="close-button" onClick={onClose}>×</button>
      </div>

      {/* Mensagens de feedback */}
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {/* Botão para criar nova empresa */}
      <div className="empresas-actions">
        <button className="create-button" onClick={handleCreate}>
          + Nova Empresa
        </button>
      </div>

      {/* Lista de empresas */}
      <div className="empresas-list">
        {loading ? (
          <div className="loading">Carregando empresas...</div>
        ) : empresas.length === 0 ? (
          <div className="no-empresas">
            <p>Nenhuma empresa cadastrada.</p>
            <p>Clique em "Nova Empresa" para começar.</p>
          </div>
        ) : (
          <div className="empresas-table-container">
            <table className="empresas-table">
              <thead>
                <tr>
                  <th>Empresa</th>
                  <th>CNPJ</th>
                  <th>E-mail</th>
                  <th>Cidade</th>
                  <th>Responsável</th>
                  <th>Contato</th>
                  <th>Status</th>
                  <th>Criada em</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {empresas.map((empresa) => (
                  <tr key={empresa.id} className={!empresa.ativa ? 'empresa-inativa' : ''}>
                    <td className="empresa-nome">
                      <div className="empresa-info">
                        <strong>{empresa.empresa}</strong>
                        {empresa.endereco && (
                          <small className="empresa-endereco">{empresa.endereco}</small>
                        )}
                      </div>
                    </td>
                    <td className="empresa-cnpj">
                      {empresa.cnpj || '-'}
                    </td>
                    <td className="empresa-email">
                      {empresa.email || '-'}
                    </td>
                    <td className="empresa-cidade">
                      {empresa.cidade || '-'}
                    </td>
                    <td className="empresa-responsavel">
                      {empresa.responsavel || '-'}
                    </td>
                    <td className="empresa-contato">
                      {empresa.contato || '-'}
                    </td>
                    <td className="empresa-status">
                      <span className={`status-badge ${empresa.ativa ? 'status-ativa' : 'status-inativa'}`}>
                        {empresa.ativa ? 'ATIVA' : 'INATIVA'}
                      </span>
                    </td>
                    <td className="empresa-data">
                      {new Date(empresa.created_at).toLocaleDateString('pt-BR')}
                    </td>
                    <td className="empresa-actions">
                      <div className="actions-buttons">
                        <button
                          type="button"
                          className="edit-button"
                          onClick={() => openDadosBancarios(empresa)}
                          title="Dados bancários"
                        >
                          🏦
                        </button>
                        <button
                          type="button"
                          className="edit-button"
                          onClick={() => openParametrosVistoria(empresa)}
                          title="Parâmetros de vistoria"
                        >
                          🚗
                        </button>
                        <button 
                          className="edit-button"
                          onClick={() => handleEdit(empresa)}
                          title="Editar empresa"
                        >
                          ✏️
                        </button>
                        <button 
                          className={`toggle-status-button ${empresa.ativa ? 'desativar' : 'ativar'}`}
                          onClick={() => handleToggleStatus(empresa)}
                          title={empresa.ativa ? 'Desativar empresa' : 'Ativar empresa'}
                        >
                          {empresa.ativa ? '⏸️' : '▶️'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>



      {/* Formulário para criar/editar empresa */}
      {showForm && (
        <div className="modal-overlay" onClick={handleCloseForm}>
          <div className="empresa-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingEmpresa ? 'Editar Empresa' : 'Nova Empresa'}</h3>
              <button className="modal-close" onClick={handleCloseForm}>×</button>
            </div>
            
            <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
              <div className="modal-body">
                {/* Informações Básicas */}
                <div className="form-section">
                  <h4>Informações Básicas</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="empresa">Nome da Empresa *</label>
                      <input
                        type="text"
                        id="empresa"
                        value={formData.empresa}
                        onChange={(e) => setFormData({ ...formData, empresa: e.target.value })}
                        placeholder="Digite o nome da empresa"
                        maxLength={255}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="razao_social">Razão Social</label>
                      <input
                        type="text"
                        id="razao_social"
                        value={formData.razao_social}
                        onChange={(e) => setFormData({ ...formData, razao_social: e.target.value })}
                        placeholder="Digite a razão social"
                        maxLength={255}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group cnpj-field-group">
                      <label htmlFor="cnpj">CNPJ</label>
                      <div className="cnpj-input-row">
                        <input
                          type="text"
                          id="cnpj"
                          value={formData.cnpj}
                          onChange={(e) => setFormData({ ...formData, cnpj: formatCNPJ(e.target.value) })}
                          placeholder="XX.XXX.XXX/XXXX-XX"
                          maxLength={18}
                          disabled={consultandoCnpj}
                          autoComplete="off"
                        />
                        <button
                          type="button"
                          className="btn-buscar-cnpj"
                          onClick={handleBuscarCnpj}
                          disabled={consultandoCnpj || saving}
                          title="Buscar dados na Receita Federal (BrasilAPI)"
                        >
                          {consultandoCnpj ? (
                            <>
                              <span className="spinner cnpj-spinner" />
                              Buscando…
                            </>
                          ) : (
                            'Buscar CNPJ'
                          )}
                        </button>
                      </div>
                      <small className="form-help">
                        Preencha o CNPJ e clique em Buscar para carregar razão social, endereço e telefone automaticamente.
                      </small>
                    </div>
                    <div className="form-group">
                      <label htmlFor="logo">Logo da Empresa</label>
                      <div className="logo-upload-section" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {(logoPreview || formData.logo) && (
                          <div className="logo-preview" style={{ padding: '10px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>
                            <img 
                              src={logoPreview || formData.logo} 
                              alt="Logo Preview" 
                              style={{ maxWidth: '100%', maxHeight: '100px', objectFit: 'contain' }} 
                            />
                            <div style={{ marginTop: '5px' }}>
                              <button 
                                type="button" 
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => { setFormData({ ...formData, logo: '' }); limparLogoSelecionada() }}
                                style={{ fontSize: '0.8rem', padding: '2px 8px' }}
                              >
                                Remover Logo
                              </button>
                            </div>
                          </div>
                        )}
                        
                        <div className="file-input-wrapper">
                          <input
                            type="file"
                            id="logo"
                            accept="image/*"
                            onChange={handleLogoSelect}
                            disabled={uploadingLogo}
                            className="form-control"
                            style={{ padding: '8px' }}
                          />
                          {logoFile && !uploadingLogo && (
                            <div className="upload-status" style={{ color: '#28a745', fontSize: '0.9rem', marginTop: '5px' }}>
                              ✓ Imagem selecionada. Será enviada ao salvar.
                            </div>
                          )}
                          {uploadingLogo && <div className="upload-status" style={{ color: '#667eea', fontSize: '0.9rem', marginTop: '5px' }}>⏳ Enviando imagem...</div>}
                        </div>
                        <small className="form-text text-muted">
                          Recomendado: Imagem PNG ou JPG com fundo transparente.
                        </small>
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="cor_primaria_contrato">Cor primária do contrato</label>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <input
                          type="color"
                          value={formData.cor_primaria_contrato || '#1a202c'}
                          onChange={(e) => setFormData({ ...formData, cor_primaria_contrato: e.target.value })}
                          style={{ width: '46px', height: '38px', padding: '2px', cursor: 'pointer' }}
                          title="Cor primária (títulos/fundo das seções) do contrato"
                        />
                        <input
                          type="text"
                          id="cor_primaria_contrato"
                          value={formData.cor_primaria_contrato}
                          onChange={(e) => setFormData({ ...formData, cor_primaria_contrato: e.target.value })}
                          placeholder="Ex.: #020001 (padrão se vazio)"
                          maxLength={9}
                          className="form-control"
                        />
                        {formData.cor_primaria_contrato && (
                          <button type="button" className="btn btn-sm btn-outline-danger" style={{ fontSize: '0.8rem', padding: '2px 8px' }} onClick={() => setFormData({ ...formData, cor_primaria_contrato: '' })}>Limpar</button>
                        )}
                      </div>
                      <small className="form-text text-muted">Usada nos títulos das seções e no cabeçalho do contrato.</small>
                    </div>
                    <div className="form-group">
                      <label htmlFor="cor_destaque_contrato">Cor de destaque do contrato</label>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <input
                          type="color"
                          value={formData.cor_destaque_contrato || '#f58220'}
                          onChange={(e) => setFormData({ ...formData, cor_destaque_contrato: e.target.value })}
                          style={{ width: '46px', height: '38px', padding: '2px', cursor: 'pointer' }}
                          title="Cor de destaque (accent) do contrato"
                        />
                        <input
                          type="text"
                          id="cor_destaque_contrato"
                          value={formData.cor_destaque_contrato}
                          onChange={(e) => setFormData({ ...formData, cor_destaque_contrato: e.target.value })}
                          placeholder="Ex.: #30F37B (padrão se vazio)"
                          maxLength={9}
                          className="form-control"
                        />
                        {formData.cor_destaque_contrato && (
                          <button type="button" className="btn btn-sm btn-outline-danger" style={{ fontSize: '0.8rem', padding: '2px 8px' }} onClick={() => setFormData({ ...formData, cor_destaque_contrato: '' })}>Limpar</button>
                        )}
                      </div>
                      <small className="form-text text-muted">Usada em bordas, destaques e detalhes do contrato.</small>
                    </div>
                  </div>
                </div>

                {/* Contato */}
                <div className="form-section">
                  <h4>Contato</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email">E-mail</label>
                      <input
                        type="email"
                        id="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="contato@empresa.com.br"
                        maxLength={255}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="contato">Telefone/Contato</label>
                      <input
                        type="text"
                        id="contato"
                        value={formData.contato}
                        onChange={(e) => setFormData({ ...formData, contato: formatPhone(e.target.value) })}
                        placeholder="(XX) XXXXX-XXXX"
                        maxLength={15}
                      />
                    </div>
                  </div>
                </div>

                {/* Endereço */}
                <div className="form-section">
                  <h4>Endereço</h4>
                  <div className="form-group">
                    <label htmlFor="endereco">Endereço Completo</label>
                    <textarea
                      id="endereco"
                      value={formData.endereco}
                      onChange={(e) => setFormData({ ...formData, endereco: e.target.value })}
                      placeholder="Digite o endereço completo da empresa"
                      rows={3}
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="cep">CEP</label>
                      <input
                        type="text"
                        id="cep"
                        value={formData.cep}
                        onChange={(e) => setFormData({ ...formData, cep: formatCEP(e.target.value) })}
                        placeholder="XXXXX-XXX"
                        maxLength={9}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="cidade">Cidade</label>
                      <input
                        type="text"
                        id="cidade"
                        value={formData.cidade}
                        onChange={(e) => setFormData({ ...formData, cidade: e.target.value })}
                        placeholder="Digite a cidade"
                        maxLength={100}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="estado">Estado (UF)</label>
                      <input
                        type="text"
                        id="estado"
                        value={formData.estado}
                        onChange={(e) => setFormData({ ...formData, estado: e.target.value.toUpperCase() })}
                        placeholder="PA"
                        maxLength={2}
                      />
                    </div>
                  </div>
                </div>

                {/* Responsável */}
                <div className="form-section">
                  <h4>Responsável</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="responsavel">Nome do Responsável</label>
                      <input
                        type="text"
                        id="responsavel"
                        value={formData.responsavel}
                        onChange={(e) => setFormData({ ...formData, responsavel: e.target.value })}
                        placeholder="Nome do responsável"
                        maxLength={255}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="cpf_responsavel">CPF do Responsável</label>
                      <input
                        type="text"
                        id="cpf_responsavel"
                        value={formData.cpf_responsavel}
                        onChange={(e) => setFormData({ ...formData, cpf_responsavel: formatCPF(e.target.value) })}
                        placeholder="XXX.XXX.XXX-XX"
                        maxLength={14}
                      />
                    </div>
                  </div>
                </div>

                {/* Status */}
                <div className="form-section">
                  <h4>Status</h4>
                  <div className="form-group">
                    <div className="checkbox-wrapper">
                      <input
                        type="checkbox"
                        id="ativa"
                        checked={formData.ativa}
                        onChange={(e) => setFormData({ ...formData, ativa: e.target.checked })}
                      />
                      <label htmlFor="ativa">Empresa ativa</label>
                    </div>
                    <small className="form-help">
                      Empresas inativas não permitem login de usuários
                    </small>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn-cancel" onClick={handleCloseForm} disabled={saving}>
                  Cancelar
                </button>
                <button type="submit" className="btn-save" disabled={saving}>
                  {saving ? (
                    <>
                      <span className="spinner"></span>
                      {editingEmpresa ? 'Atualizando...' : 'Salvando...'}
                    </>
                  ) : (
                    editingEmpresa ? 'Atualizar' : 'Salvar'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de dados bancários */}
      {showDadosBancariosModal && empresaDadosBancarios && (
        <div className="modal-overlay" onClick={closeDadosBancarios}>
          <div className="empresa-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🏦 Dados bancários — {empresaDadosBancarios.empresa}</h3>
              <button className="modal-close" onClick={closeDadosBancarios}>×</button>
            </div>
            <form onSubmit={handleSaveDadosBancarios}>
              <div className="modal-body">
                <div className="form-section">
                  <h4>Dados bancários</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="banco">Banco</label>
                      <input
                        type="text"
                        id="banco"
                        value={formDadosBancarios.banco}
                        onChange={(e) => setFormDadosBancarios({ ...formDadosBancarios, banco: e.target.value })}
                        placeholder="Nome ou código do banco"
                        maxLength={255}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="agencia">Agência</label>
                      <input
                        type="text"
                        id="agencia"
                        value={formDadosBancarios.agencia}
                        onChange={(e) => setFormDadosBancarios({ ...formDadosBancarios, agencia: e.target.value })}
                        placeholder="Número da agência"
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="conta">Conta</label>
                      <input
                        type="text"
                        id="conta"
                        value={formDadosBancarios.conta}
                        onChange={(e) => setFormDadosBancarios({ ...formDadosBancarios, conta: e.target.value })}
                        placeholder="Número da conta"
                        maxLength={50}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="chave_pix">Chave PIX</label>
                      <input
                        type="text"
                        id="chave_pix"
                        value={formDadosBancarios.chave_pix}
                        onChange={(e) => setFormDadosBancarios({ ...formDadosBancarios, chave_pix: e.target.value })}
                        placeholder="CPF, e-mail, telefone ou chave aleatória"
                        maxLength={255}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn-cancel" onClick={closeDadosBancarios} disabled={savingDadosBancarios}>
                  Cancelar
                </button>
                <button type="submit" className="btn-save" disabled={savingDadosBancarios}>
                  {savingDadosBancarios ? (
                    <>
                      <span className="spinner"></span>
                      Salvando...
                    </>
                  ) : (
                    'Salvar'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de parâmetros de vistoria */}
      {showParametrosVistoriaModal && empresaParametrosVistoria && (
        <div className="modal-overlay" onClick={closeParametrosVistoria}>
          <div className="empresa-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🚗 Parâmetros de vistoria — {empresaParametrosVistoria.empresa}</h3>
              <button className="modal-close" onClick={closeParametrosVistoria}>×</button>
            </div>
            <div className="modal-body">
              {/* Lista de parâmetros cadastrados (consultar) */}
              <div className="form-section">
                <h4>Parâmetros cadastrados</h4>
                {loadingParametrosVistoria ? (
                  <p>Carregando...</p>
                ) : parametrosVistoria.length === 0 ? (
                  <p>Nenhum parâmetro cadastrado para esta empresa.</p>
                ) : (
                  <table className="empresas-table">
                    <thead>
                      <tr>
                        <th>Tipo de veículo</th>
                        <th>Valor do km</th>
                        <th>Km almoço</th>
                        <th>Valor almoço</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parametrosVistoria.map((p) => (
                        <tr key={p.id}>
                          <td style={{ textTransform: 'capitalize' }}>{p.tipo_veiculo}</td>
                          <td>R$ {formatarNumeroParametro(p.valor_km)}</td>
                          <td>{formatarNumeroParametro(p.km_almoco)} km</td>
                          <td>R$ {formatarNumeroParametro(p.valor_almoco)}</td>
                          <td>
                            <div className="actions-buttons">
                              <button
                                type="button"
                                className="edit-button"
                                onClick={() => editarParametroVistoria(p)}
                                title="Editar parâmetro"
                              >
                                ✏️
                              </button>
                              <button
                                type="button"
                                className="toggle-status-button desativar"
                                onClick={() => handleDeleteParametroVistoria(p)}
                                title="Excluir parâmetro"
                              >
                                🗑️
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Formulário cadastrar/editar */}
              <form onSubmit={handleSaveParametroVistoria}>
                <div className="form-section">
                  <h4>{editandoParametroVistoriaId ? 'Editar parâmetro' : 'Novo parâmetro'}</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="tipo_veiculo">Tipo de veículo</label>
                      <select
                        id="tipo_veiculo"
                        value={formParametroVistoria.tipo_veiculo}
                        onChange={(e) => setFormParametroVistoria({ ...formParametroVistoria, tipo_veiculo: e.target.value })}
                      >
                        <option value="carro">Carro</option>
                        <option value="moto">Moto</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="valor_km">Valor do km (R$)</label>
                      <input
                        type="text"
                        id="valor_km"
                        inputMode="decimal"
                        value={formParametroVistoria.valor_km}
                        onChange={(e) => setFormParametroVistoria({ ...formParametroVistoria, valor_km: e.target.value })}
                        placeholder="0,00"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="km_almoco">Km para cobrar almoço</label>
                      <input
                        type="text"
                        id="km_almoco"
                        inputMode="decimal"
                        value={formParametroVistoria.km_almoco}
                        onChange={(e) => setFormParametroVistoria({ ...formParametroVistoria, km_almoco: e.target.value })}
                        placeholder="0,00"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="valor_almoco">Valor do almoço (R$)</label>
                      <input
                        type="text"
                        id="valor_almoco"
                        inputMode="decimal"
                        value={formParametroVistoria.valor_almoco}
                        onChange={(e) => setFormParametroVistoria({ ...formParametroVistoria, valor_almoco: e.target.value })}
                        placeholder="0,00"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  {editandoParametroVistoriaId && (
                    <button type="button" className="btn-cancel" onClick={cancelarEdicaoParametroVistoria} disabled={savingParametroVistoria}>
                      Cancelar edição
                    </button>
                  )}
                  <button type="button" className="btn-cancel" onClick={closeParametrosVistoria} disabled={savingParametroVistoria}>
                    Fechar
                  </button>
                  <button type="submit" className="btn-save" disabled={savingParametroVistoria}>
                    {savingParametroVistoria ? (
                      <>
                        <span className="spinner"></span>
                        Salvando...
                      </>
                    ) : (
                      editandoParametroVistoriaId ? 'Atualizar' : 'Cadastrar'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal de erro com prioridade máxima */}
      {showErrorModal && (
        <div className="error-modal-overlay" onClick={closeErrorModal}>
          <div className="error-modal" onClick={(e) => e.stopPropagation()}>
            <div className="error-modal-header">
              <h3>
                ⚠️ Erro
              </h3>
              <button className="error-modal-close" onClick={closeErrorModal}>×</button>
            </div>
            
            <div className="error-modal-body">
              <p><strong>{error}</strong></p>
              {errorDetails && <p>{errorDetails}</p>}
            </div>
            
            <div className="error-modal-footer">
              <button className="error-modal-button" onClick={closeErrorModal}>
                Entendi
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Empresas
